// extracted by mini-css-extract-plugin
module.exports = {"desktop":"_2bbxx","compact":"_2qUVk","mobile":"_3LGDY"};